import BaseApi from '../base.api';

export class EnumApi extends BaseApi {
  public async getEnums(): Promise<any> {
    return await this.get('/api/enum');
  }
}
